import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=78b00ecc&scoped=true&"
import script from "./EmailVerification.vue?vue&type=script&lang=js&"
export * from "./EmailVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=78b00ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b00ecc",
  null
  
)

export default component.exports